import React from 'react';

const Products = () => {
    return (
        <div>
            <h2>this is Products</h2>
        </div>
    );
};

export default Products;